interface TigolaLogoProps {
  className?: string;
  alt?: string;
  size?: "sm" | "md" | "lg"; // kept for backward compatibility (unused)
}

import { OptimizedImage } from "@/components/OptimizedImage";

export function TigolaLogo({
  className = "",
  alt = "Tigola - Professional Transport UK",
}: TigolaLogoProps) {
  return (
    <OptimizedImage
      src="/tigola-logo.png"
      alt={alt}
      className={`h-12 w-auto ${className}`}
      loading="eager"
      decoding="async"
      deriveCandidates={false}
    />
  );
}

export default TigolaLogo;
